module.exports = __webpack_public_path__ + "img/english-home.532b401a.svg";